import { TableDataType } from "./eums"
import { TableColumnsInterface } from "./interfaces"

export const tableActivityColumns: TableColumnsInterface[] = [
  {
    value: "user_id",
    title: "User Id",
    format: TableDataType.SHORTENED_STRING,
    sorting: true,
    mntSorting: false
  },
  {
    value: "username",
    title: "Username",
    format: TableDataType.STRING,
    sorting: false
  },
  {
    value: "resource_type",
    title: "Resource type",
    format: TableDataType.NUMBER,
    sorting: true,
    mntSorting: false
  },
  {
    value: "resource_id",
    title: "Resource ID",
    format: TableDataType.SHORTENED_STRING,
    sorting: true,
    mntSorting: false
  },
  {
    value: "action",
    title: "Action",
    format: TableDataType.STRING,
    sorting: true,
    mntSorting: false
  },
  {
    value: "data",
    title: "Resource data",
    format: TableDataType.STRING,
    sorting: false
  },
  {
    value: "created_at",
    title: "Created At",
    format: TableDataType.DATE,
    sorting: true
  }
]
